
import Vue, {PropType} from 'vue'
import DatasetChangeView from './DatasetChangeView.vue';
import StreamChangeView from './StreamChangeView.vue';
const _ = require('lodash');
import {
  DatasetsDiff, StreamsDiff, DatasetContent, StreamContent
} from '../../types'
export default Vue.extend({
  name: 'DatasetDiffView',
   data() {
    return {
      tab: null,
      
    };
  },
  components :{
    DatasetChangeView,
    StreamChangeView
  },
  methods: {    
    contentStr(object : DatasetContent | StreamContent){
      if("datasets" in object){
        return object.datasets.join("\n ")
      }else{
        return object.paths.map(x=> `${x.name} / ${x.prescale}`).join("\n ")
      }
    }
  },
  computed: {
    
  },
  props:{
    datasetDiffs : {type : Object as PropType<DatasetsDiff | StreamsDiff>, required : false},
    streamMode : {type : Boolean, default : false}
  }
  
})
